export default "__VITE_ASSET__qVE3VoVd__"